export const dateFormat = (language) => {
  const sample = window.Intl
    ? new Intl.DateTimeFormat(language).format(new Date(1970, 11, 31))
    : '';

  let mm = 0;
  const mi = sample.indexOf(12);

  let dd = 1;
  const di = sample.indexOf(31);

  let yy = 2;
  const yi = sample.indexOf(1970);

  // IE 10 or earlier, iOS 9 or earlier, non-Latin numbering system
  // or non-Gregorian calendar; fall back to mm/dd/yyyy
  if (yi >= 0 && mi >= 0 && di >= 0) {
    mm = (mi > yi) + (mi > di);
    dd = (di > yi) + (di > mi);
    yy = (yi > mi) + (yi > di);
  }

  const r = [];
  r[yy] = 'YYYY';
  r[mm] = 'MM';
  r[dd] = 'DD';

  return r;
};
